<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-container" (click)="stopPropagation($event)">

    <!-- Header -->
    <div class="modal-header">
      <div>
        <h3 class="modal-title">Seleccione una Configuración</h3>
        <p class="modal-subtitle" *ngIf="fuenteName">{{ fuenteName }}</p>
      </div>
      <button class="btn-close" (click)="closeModal()" aria-label="Cerrar">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">

      <!-- Loading -->
      <div *ngIf="loading" class="loading-container">
        <div class="spinner-border text-primary" role="status"></div>
        <span class="text-muted ms-3">Cargando configuraciones...</span>
      </div>

      <!-- Configs List -->
      <div *ngIf="!loading && availableConfigs && availableConfigs.length > 0" class="configs-list">
        <div *ngFor="let config of availableConfigs"
             class="config-item"
             (click)="selectConfig(config)">
          <div class="config-content">
            <div class="config-name">
              <span class="material-symbols-outlined me-2">settings</span>
              {{ config.name || config }}
            </div>
            <div class="config-description">
              {{ config.description || 'Sin descripción' }}
            </div>
          </div>
          <span class="material-symbols-outlined chevron">chevron_right</span>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && (!availableConfigs || availableConfigs.length === 0)" class="empty-state">
        <span class="material-symbols-outlined">info</span>
        <p>No se encontraron configuraciones disponibles</p>
      </div>

    </div>

  </div>
</div>

